import { ref } from 'vue'

/** True while a tracking-tear glitch is playing (~550ms every ~10s). */
export const crtTearing = ref(false)
/** Vertical position (%) of the tear bar. */
export const crtTearY = ref(50)

const TEAR_MS = 550
const IDLE_MIN_MS = 30000
const IDLE_JITTER_MS = 30000

function motionOk(): boolean {
  return (
    typeof window !== 'undefined' &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}

/**
 * Starts the tracking-tear loop. Only meaningful while the CRT overlay is
 * mounted. Returns a stop function (also clears a mid-tear state).
 */
export function startCrtTearLoop(): () => void {
  let alive = true
  let tearTimer: ReturnType<typeof setTimeout> | null = null
  let idleTimer: ReturnType<typeof setTimeout> | null = null

  const tick = (): void => {
    if (!alive) return
    if (typeof document !== 'undefined' && !document.hidden && motionOk()) {
      crtTearY.value = 25 + Math.random() * 50
      crtTearing.value = true
      tearTimer = setTimeout(() => {
        crtTearing.value = false
      }, TEAR_MS)
    }
    idleTimer = setTimeout(tick, IDLE_MIN_MS + Math.random() * IDLE_JITTER_MS)
  }

  if (typeof window !== 'undefined') {
    idleTimer = setTimeout(tick, IDLE_MIN_MS + Math.random() * IDLE_JITTER_MS)
  }

  return () => {
    alive = false
    if (idleTimer) clearTimeout(idleTimer)
    if (tearTimer) clearTimeout(tearTimer)
    crtTearing.value = false
  }
}
